import React, { Component } from 'react';
import moment from 'moment';
import axios from 'axios';
import { withStyles, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { exists, isEmpty, convertTimeInMinutes, currentHttpOptions } from '../../../../common/utilities/utilitiesFunctions';
import SideBar from '../../../../common/components/UI/SideBar/SideBar';
import ActionButtons from '../../../../common/components/UI/ActionButtons/ActionButtons';
import { updateSnackbar, updateShowSidePanel, updateSelectedPaycode, updateSelectedWorkPlan, updateSpinnerShow } from '../actions';
import ChipTagStatus from '../../../../common/components/UI/ChipTagStatus/ChipTagStatus';
import * as aux from '../../../auxilaries';
import { StateStatus, UkgDateFormat, WorkplanActions } from '../../../Enums/index';
import {
    evalForeverToNull,
    evalForeverDateToString,
    evalForeverStringToDate,
    isStateIndirect
} from './functions';
import * as actionFormContent from './actionFormContent';
import DateFormatService from '../../../services/DateFormatService';

const styles = theme => ({
    sideBar: {
        minWidth: 480,
        maxWidth: 960,
        backgroundColor: 'white',
        height: '100%',
    },
    sideBarTitle: {
        fontSize: 16,
        // fontFamily: 'Montserrat, Regular',
        letterSpacing: '0',
        color: '#3A3A3A',
        opacity: '1',
        fontWeight: 'bold',
        textAlign: 'left',
    },
    SideBarSubmitText: {
        textTransform: 'none',
        textAlign: 'left',
        // font: 'Bold 12px/18px Roboto',
        // fontFamily: 'Roboto',
        letterSpacing: '0',
        color: '#FFFFFF',
        opacity: '1'
    },
    formContainer: {
        padding: '0 24px',
        backgroundColor: '#F8FAFC',
        position: 'absolute',
        width: '100%',
    },
    dateTypo: {
        flex: '1',
        color: '#878787',
        fontSize: '12px'
    },
    arrowIcon: {
        marginRight: 5,
        marginLeft: 5,
        height: 20
    },
    tagStatus: {
        marginTop: 5
    },
    formContent: {
        '& > *': {
            marginBottom: 10
        }
    },
    reliefContainer: {
        border: '1px solid #cecece',
        padding: 12,
        borderRadius: 4,
        marginBottom: 8
    },
    reliefContainerHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8
    },
    reliefTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#3a3a3a',
    }
})

class ActionForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            action: '',
            selectedStartDate: null,
            selectedEndDate: null,
            selectedEmployee: '',
            startOn: 1,
            note: '',
            startTime: '',
            duration: '',
            formTitle: '',
            shiftLineId: '',
            isNewLine: '',
            lineId: '',
            employeeList: [],
            shiftLineStates: [],
            shiftLine: '',
            shiftLineOwner: '',
            owner: '',
            Reliefs: [],
            pushCoverage: false,
            pushPlanned: false,
            ownersToSave: [],
            radioOverlapSelected: 'yes',
            reliefOverlapped: [],
            shift: {},
            shiftlineJob: {},
            refreshAdmin: null,
            shiftSegmentsSended: [],
            shiftSegmentsSCP: [],
            shiftTemplateDay: 0,
            shiftlineId: 0
        }
    }

    componentDidUpdate = prevProps => {
        if (this.props.showSidePanel !== prevProps.showSidePanel) {
            this.setState({
                action: exists(this.props.sidePanelData.action) ? this.props.sidePanelData.action : '',
                selectedStartDate: exists(this.props.sidePanelData.selectedStartDate) ? this.props.sidePanelData.selectedStartDate : null,
                selectedEndDate: exists(this.props.sidePanelData.selectedEndDate) ? this.props.sidePanelData.selectedEndDate : null,
                selectedEmployee: exists(this.props.sidePanelData.selectedEmployee) ? this.props.sidePanelData.selectedEmployee : '',
                startOn: this.props.selectedWorkPlan.startDateOffset ? this.props.selectedWorkPlan.startDateOffset : 1,
                note: exists(this.props.sidePanelData.note) ? this.props.sidePanelData.note : '',
                startTime: exists(this.props.sidePanelData.startTime) ? this.props.sidePanelData.startTime : '',
                duration: exists(this.props.sidePanelData.duration) ? this.props.sidePanelData.duration : '',
                formTitle: exists(this.props.sidePanelData.formTitle) ? this.props.sidePanelData.formTitle : '',
                shiftLineId: exists(this.props.sidePanelData.shiftLineId) ? this.props.sidePanelData.shiftLine.shiftLineId : '',
                isNewLine: exists(this.props.sidePanelData.isNewLine) ? this.props.sidePanelData.shiftLine.isNewLine : '',
                lineId: exists(this.props.sidePanelData.lineId) ? this.props.sidePanelData.lineId : '',
                employeeList: exists(this.props.sidePanelData.employeeList) ? this.props.sidePanelData.employeeList : [],
                shiftLineStates: exists(this.props.sidePanelData.shiftLineStates) ? this.props.sidePanelData.shiftLine.shiftLineStates : [],
                shiftLine: exists(this.props.sidePanelData.shiftLine) ? this.props.sidePanelData.shiftLine : '',
                shiftLineOwner: exists(this.props.sidePanelData.shiftLineOwner) ? this.props.sidePanelData.shiftLineOwner : '',
                owner: exists(this.props.sidePanelData.owner) ? this.props.sidePanelData.owner : '',
                shift: exists(this.props.sidePanelData.shift) ? this.props.sidePanelData.shift : null,
                shiftlineJob: exists(this.props.sidePanelData.shiftlineJob) ? this.props.sidePanelData.shiftlineJob : null,
                refreshAdmin: exists(this.props.sidePanelData.refreshAdmin) ? this.props.sidePanelData.refreshAdmin : null,
                shiftTemplateDay: exists(this.props.sidePanelData.shiftTemplateDay) ? this.props.sidePanelData.shiftTemplateDay : null,
                shiftlineId: exists(this.props.sidePanelData.shiftlineId) ? this.props.sidePanelData.shiftlineId : null,
                shiftSegmentsSCP: exists(this.props.sidePanelData.shiftSegmentsSCP) ? this.props.sidePanelData.shiftSegmentsSCP : null,
            })
        }
    }

    handleChangeEmployee = (shiftLine, value, ownersToSave) => {
        this.setState({
            selectedEmployee: {
                shiftLine,
                employeeId: value.value,
                employeeName: value.label
            },
            ownersToSave,
        });
    }

    handleChangeOwners = (ownersToSave) => {
        this.setState({ ownersToSave });
    }

    handleChangeUpdatedReliefs = (updatedReleafs) => {
        this.setState({ shiftLine: { ...this.state.shiftLine, updatedReleafs } });
    }

    handleAddReliefs = (shiftLine, reliefsList, startDate = moment(), endDate = moment()) => {
        let auxReliefList = [];
        for (const relief of reliefsList) {
            let auxRelief = {};

            if (relief.employee !== "" && (relief.isNew || relief.detailsChanged || relief.markAsDelete)) {
                auxRelief = {
                    shiftLineEntityId: shiftLine.shiftLineId,
                    isNew: relief.isNew,
                    detailsChanged: relief.detailsChanged,
                    job: {
                        nodeId: shiftLine.job.value,
                        orgPath: shiftLine.job.label,
                    },
                    schedulePatternName: shiftLine.schedulePatternName,
                    startDate: relief.startDate,
                    endDate: evalForeverStringToDate(relief.endDate),
                    employeeId: relief.employee.value,
                    employeeName: relief.employee.name,
                    markedForDeletion: relief.markAsDelete,
                    reliefId: relief.id,
                    isJobTransfer: relief.employee.isJobTransfer,
                    details: []
                }

                if (!isEmpty(shiftLine.shiftTemplates)) {
                    for (const shiftTemplate of shiftLine.shiftTemplates) {
                        auxRelief.details.push({
                            day: shiftTemplate.day,
                            ShiftTemplate: {
                                ShiftTemplateId: shiftTemplate.kronosShiftTemplate.id,
                                Name: shiftTemplate.kronosShiftTemplate.name,
                                Description: '',
                                StartDateTime: shiftTemplate.kronosShiftTemplate.startDateTime,
                                EndDateTime: shiftTemplate.kronosShiftTemplate.endDateTime,
                                Label: shiftTemplate.kronosShiftTemplate.label,
                                Segments: shiftTemplate.kronosShiftTemplate.segments
                            },
                        });
                    }
                }

                if (!isEmpty(shiftLine.paycodeTemplates)) {
                    for (const payCode of shiftLine.paycodeTemplates) {
                        auxRelief.details.push({
                            day: payCode.day,
                            PayCodeTemplate: {
                                PayCode: { id: payCode.id },
                                Id: payCode.id,
                                Name: payCode.name,
                                DurationInTime: typeof (payCode.durationInTime) === 'string' ? parseInt(convertTimeInMinutes(payCode.durationInTime)) : payCode.durationInTime,
                                StartDateTime: payCode.startTime
                            }
                        })
                    }
                }

                auxReliefList.push(auxRelief)
            }
        }
        this.setState({
            shiftLineId: shiftLine.shiftLineId,
            shiftLine: shiftLine,
            Reliefs: auxReliefList,
            selectedStartDate: startDate,
            selectedEndDate: endDate
        })
    }

    handleChangeValue = (value, target) => {
        const { updateSelectedPaycode } = this.props;
        const { selectedEndDate } = this.state
        switch (target) {
            case 'duration':
                let splitValue = value.split(':');

                this.setState({ [target]: splitValue[0] + ':' + (splitValue[1] > 59 ? 59 : splitValue[1]) });
                break;
            case 'selectedStartDate':
                let isStartDateAfterEndDate = selectedEndDate && moment(value).isSameOrAfter(moment(selectedEndDate), 'd')
                this.setState({
                    selectedStartDate: value,
                    selectedEndDate: isStartDateAfterEndDate ? null : this.state.selectedEndDate
                });
                break;
            case 'paycode':
                updateSelectedPaycode(value);
                break;
            default:
                this.setState({ [target]: value });
                break;
        }
    }

    getMinDateShiftLine = (offset = 0) => {
        const { shiftLine } = this.state;
        let date = shiftLine.states.length > 0 ? moment(shiftLine.states[0].effectiveDate) : moment().add(offset, 'd');
        return moment(date).isAfter(moment().add(offset, 'd'), 'day') ? date : moment().add(offset, 'd');
    }

    getMaxDateShiftLine = (workplanMaxDate) => {
        const { shiftLine } = this.state;
        const momentWorkplanMaxDate = moment(workplanMaxDate);

        const shiftLineStopState = shiftLine.states.find((state) => state.status === StateStatus.Stopped);
        if (shiftLineStopState) {
            const momentShiftLineStoppedEndDate = moment(shiftLineStopState.endDate).add(-1, 'd');
            return momentShiftLineStoppedEndDate.isBefore(momentWorkplanMaxDate) ? momentShiftLineStoppedEndDate : momentWorkplanMaxDate;
        }

        const shiftLineStatesWithoutStop = shiftLine.states.filter((state) => state.status !== StateStatus.Stopped);
        if (shiftLineStatesWithoutStop) {
            const maxEndDateState = shiftLineStatesWithoutStop.reduce((max, state) => {
                return state.endDateEpoch > max.endDateEpoch ? state : max;
            });
            return moment(maxEndDateState.endDate)
        }

        return workplanMaxDate;
    }

    disablePauseShiftLineDates = (date) => {
        const { shiftLineStates } = this.state;

        for (const status of shiftLineStates) {
            if (status.value === 1 && moment(date).isBetween(moment(status.effectiveDate), moment(status.endDate), 'd', '[]')) {
                return true;
            }
        }
        return false;
    }

    chipStatus = (statusId, isIndirect = false) => {
        let color = ''

        switch (statusId) {
            case 0: color = 'green' + (isIndirect ? 'Alt' : ''); break;
            case 1: color = 'yellow' + (isIndirect ? 'Alt' : ''); break;
            case 2: color = 'red' + (isIndirect ? 'Alt' : ''); break;
            default: color = 'white'; break;
        }

        return <ChipTagStatus color={color} label={''} className={this.props.classes.tagStatus} />
    }

    generateSidePanelContent = () => {
        const { selectedWorkPlan, paycodeList, selectedPaycode, skillAndCertificationProfiles, classes, t } = this.props;
        const {
            action,
            employeeList,
            selectedStartDate,
            selectedEndDate,
            startTime,
            duration,
            startOn,
            note,
            shiftLine,
            shiftLineOwner,
            pushCoverage,
            pushPlanned,
            ownersToSave,
            Reliefs,
            shift,
            shiftlineJob,
            refreshAdmin,
            shiftlineId,
            shiftSegmentsSCP,
        } = this.state;

        let content = '';
        let okDisabled = false;
        let workplanMinDate = moment().add(1, 'd');
        let workplanMaxDate = moment(selectedWorkPlan.endDate);
        if (selectedWorkPlan.states !== null && selectedWorkPlan.states.length > 0) {
            const workplanActiveState = selectedWorkPlan.states.find((state) => state.status === StateStatus.Active);
            if (workplanActiveState) {
                workplanMaxDate = moment(workplanActiveState.endDate);
            }

            workplanMinDate = moment(selectedWorkPlan.states[0].effectiveDate).isAfter(moment(), 'day') ? moment(selectedWorkPlan.states[0].effectiveDate) : moment().add(1, 'd');
            if (selectedWorkPlan.states[selectedWorkPlan.states.length - 1].status === 2 && (selectedWorkPlan.states[0].effectiveDate === null || selectedWorkPlan.states[0].effectiveDate === undefined)) {
                workplanMinDate = selectedWorkPlan.states[selectedWorkPlan.states.length - 1].endDate;
            }
        }

        const handleAddTransfert = (listShiftSegments) => {
            listShiftSegments = listShiftSegments.map((x) => ({
                ...x,
                startDateTime: moment(x.startDateTime).format(`YYYY-MM-DDTHH:mm:ss`),
                endDateTime: moment(x.endDateTime).format(`YYYY-MM-DDTHH:mm:ss`),
            }));
            this.setState({ shiftSegmentsSended: listShiftSegments });
        }

        const handleSetSkillAndCertificationProfilesChange = (value, index) => {
            const { shiftSegmentsSCP } = this.state;
            shiftSegmentsSCP[index].segmentSCProfiles = value;
            this.setState({ shiftSegmentsSCP: shiftSegmentsSCP });
        };

        let maxDateShiftLine;
        switch (action) {
            case WorkplanActions.ManageOwners:
                let noNewOwner = shiftLine.owners !== undefined ? ownersToSave.every(owner => shiftLine.owners.includes(owner)) : false;
                okDisabled = ownersToSave.length <= 0 || noNewOwner;
                content = actionFormContent.AssignOwnersToShiftLine(classes, employeeList, this.handleChangeEmployee, this.handleChangeOwners, this.handleChangeUpdatedReliefs, shiftLine, action);
                break;
            case WorkplanActions.PauseShiftLineOwner:
            case WorkplanActions.StopShiftLineOwner:
                okDisabled = selectedEndDate === null
                content = actionFormContent.AssignOwnersToShiftLine(classes, employeeList, this.handleAddReliefs, this.handleChangeOwners, this.handleChangeUpdatedReliefs, shiftLine, action, shiftLineOwner);
                break;
            case WorkplanActions.ManageAssignment:
                let noNewRelief = shiftLine.reliefs !== undefined ? Reliefs.every(relief => shiftLine.reliefs.includes(relief)) : false;
                okDisabled = noNewRelief;
                content = actionFormContent.AssignOwnersToShiftLine(classes, employeeList, this.handleAddReliefs, this.handleChangeOwners, this.handleChangeUpdatedReliefs, shiftLine, action, shiftLineOwner);
                break;
            case WorkplanActions.RolloutWorkplan:
                okDisabled = selectedEndDate === null;
                content = actionFormContent.rolloutWorkplanAction(classes, selectedStartDate, selectedEndDate, selectedWorkPlan.periodLength, selectedWorkPlan.periodType, startOn, note, this.handleChangeValue, pushCoverage, pushPlanned, t);
                break;
            case WorkplanActions.EditRolloutWorkplan:
                okDisabled = selectedEndDate === null;
                content = actionFormContent.editRolloutWorkplanAction(classes, selectedStartDate, selectedEndDate, selectedWorkPlan, this.handleChangeValue, startOn);
                break;
            case WorkplanActions.PauseWorkplan:
                okDisabled = selectedEndDate === null;
                content = actionFormContent.pauseWorkplanAction(classes, selectedStartDate, selectedEndDate, selectedWorkPlan, note, this.handleChangeValue, workplanMinDate, workplanMaxDate, startOn);
                break;
            case WorkplanActions.EditPauseWorkplan:
                okDisabled = selectedEndDate === null;
                content = actionFormContent.editPauseWorkplanAction(classes, selectedStartDate, selectedEndDate, selectedWorkPlan, note, this.handleChangeValue, workplanMinDate, workplanMaxDate, startOn);
                break;
            case WorkplanActions.EditStopWorkplan:
            case WorkplanActions.StopWorkplan:
                okDisabled = selectedEndDate === null;
                content = actionFormContent.stopWorkplanAction(classes, selectedEndDate, note, this.handleChangeValue, workplanMinDate, moment(selectedWorkPlan.endDate));
                break;
            case WorkplanActions.PlayShiftLine:
                workplanMinDate = moment(selectedWorkPlan.states[0].effectiveDate).isAfter(moment(), 'day') ? moment(selectedWorkPlan.states[0].effectiveDate) : moment();
                okDisabled = selectedEndDate === null;
                content = actionFormContent.playShiftLineAction(classes, selectedStartDate, selectedEndDate, note, this.handleChangeValue, workplanMinDate, workplanMaxDate);
                break;
            case WorkplanActions.PauseShiftLine:
                okDisabled = selectedEndDate === null;
                maxDateShiftLine = this.getMaxDateShiftLine(workplanMaxDate);
                let minDatePauseShiftLine = moment(shiftLine.effectiveDate).isAfter(moment()) ? moment(shiftLine.effectiveDate) : moment().add(1, 'd');
                content = actionFormContent.pauseShiftLineAction(classes, selectedStartDate, selectedEndDate, note, this.handleChangeValue, shiftLine, minDatePauseShiftLine, workplanMaxDate);
                break;
            case WorkplanActions.EditPauseShiftLine:
                okDisabled = selectedEndDate === null;
                maxDateShiftLine = this.getMaxDateShiftLine(workplanMaxDate);
                let minDateEditPauseShiftLine = moment(shiftLine.effectiveDate).isAfter(moment()) ? moment(shiftLine.effectiveDate) : moment().add(1, 'd');
                content = actionFormContent.pauseShiftLineAction(classes, selectedStartDate, selectedEndDate, note, this.handleChangeValue, shiftLine, minDateEditPauseShiftLine, workplanMaxDate);
                break;
            case WorkplanActions.StopShiftLine:
                okDisabled = selectedEndDate === null;
                maxDateShiftLine = this.getMaxDateShiftLine(workplanMaxDate);
                let minDateStopShiftLine = moment(shiftLine.effectiveDate).isAfter(moment()) ? moment(shiftLine.effectiveDate) : moment().add(1, 'd');
                content = actionFormContent.stopShiftLineAction(classes, selectedEndDate, this.handleChangeValue, minDateStopShiftLine, maxDateShiftLine);
                break;
            case WorkplanActions.EditStopShiftLine:
                okDisabled = selectedEndDate === null;
                maxDateShiftLine = this.getMaxDateShiftLine(workplanMaxDate);
                let minDateEditStopShiftLine = moment(shiftLine.effectiveDate).isAfter(moment()) ? moment(shiftLine.effectiveDate) : moment().add(1, 'd');
                content = actionFormContent.editStopShiftLineAction(classes, selectedEndDate, this.handleChangeValue, minDateEditStopShiftLine, maxDateShiftLine);
                break;
            case "createPaycode":
                okDisabled = startTime === '' || duration === '';
                content = actionFormContent.createPaycodeAction(classes, selectedPaycode, paycodeList, startTime, duration, this.handleChangeValue);
                break;
            case WorkplanActions.ManageShiftLine:
                workplanMinDate = moment(selectedWorkPlan.states[0].effectiveDate).isAfter(moment(), 'day') ? moment(selectedWorkPlan.states[0].effectiveDate) : moment();
                content = actionFormContent.playShiftLineAction(classes, selectedStartDate, selectedEndDate, note, this.handleChangeValue, workplanMinDate, workplanMaxDate);
                break
            case WorkplanActions.AddJobTransfer:
                content = actionFormContent.addJobTransfer(shift, shiftlineJob, refreshAdmin, selectedWorkPlan, shiftlineId, handleAddTransfert);
                break
            case WorkplanActions.SetSkillAndCertificationProfiles:
                content = actionFormContent.setSkillAndCertificationProfiles({
                    t,
                    skillAndCertificationProfiles,
                    shift,
                    shiftlineJob,
                    shiftSegmentsSCP,
                    onValueChange: handleSetSkillAndCertificationProfilesChange});
                break
            default:
                break;
        }

        return <React.Fragment>
            <div style={{ margin: 20, textAlign: 'left', height: '82vh', overflow: 'auto', overflowX: 'hidden' }}>
                {(action === WorkplanActions.PauseWorkplan
                    || action === WorkplanActions.StopWorkplan
                    || action === WorkplanActions.EditPauseWorkplan
                    || action === WorkplanActions.EditRolloutWorkplan
                    || action === WorkplanActions.EditStopWorkplan
                    || action === WorkplanActions.ManageShiftLine)
                    ? (
                        <div>
                            <span style={{ fontWeight: 'bold', fontSize: 20 }}>{'Workplan: ' + selectedWorkPlan.name}</span>
                            <div>
                                {selectedWorkPlan.states.length > 0 ?
                                    selectedWorkPlan.states.map((state, index) => {
                                        return (
                                            <div
                                                key={`action-form-workplan-state-${state.label}-${state.effectiveDateEpoch}-${state.endDateEpoch}-${index}`}
                                                style={{ width: '100%', display: 'flex' }}
                                            >
                                                {this.chipStatus(state.status, state.isCurrent)}
                                                {state.effectiveDate === null
                                                    ? ''
                                                    : (
                                                        <React.Fragment>
                                                            <span style={{ fontSize: 16, marginLeft: 8 }}>{DateFormatService.formatDateOrEmpty(moment(state.effectiveDate).format('YYYY-MM-DD'), UkgDateFormat.LongDate)}</span>
                                                            <FontAwesomeIcon className={classes.arrowIcon} icon={faLongArrowRight} />
                                                        </React.Fragment>
                                                    )}
                                                <span style={{ fontSize: 16, marginLeft: state.effectiveDate !== null ? '' : 8 }}>{evalForeverDateToString(moment(state.endDate).format('YYYY-MM-DD'), t)}</span>
                                            </div>)
                                    }
                                    )
                                    : <span style={{ fontWeight: 'bold' }}>{t('workPlanView.slide.noDatesDefinied')}</span>}
                            </div>
                            <div style={{ border: '1px solid #E7E7E7', marginBottom: 20, marginTop: 20 }}></div>
                        </div>
                    )
                    : ''}
                {(action === WorkplanActions.StopShiftLine
                    || action === WorkplanActions.PauseShiftLine
                    || action === WorkplanActions.EditPauseShiftLine
                    || action === WorkplanActions.ManageOwners
                    || action === WorkplanActions.ManageAssignment
                    || action === WorkplanActions.PauseShiftLineOwner
                    || action === WorkplanActions.StopShiftLineOwner)
                    ? (
                        <div>
                            <span style={{ fontWeight: 'bold', fontSize: 20 }}>{"Shiftline: " + shiftLine.schedulePatternName}</span>
                            <div>
                                {shiftLine.states.length > 0 ?
                                    shiftLine.states.map((state, index) => {
                                        let isIndirect = isStateIndirect(state)
                                        return (
                                            <div
                                                key={`assignment-summary-${state.label}-${state.endDateEpoch}-${index}`}
                                                style={{ width: '100%', display: 'flex' }}
                                            >
                                                {this.chipStatus(state.status, isIndirect)}
                                                {state.effectiveDate === null ? '' :
                                                    <React.Fragment>
                                                        <span style={{ fontSize: 16, marginLeft: 8 }}>{DateFormatService.formatDateOrEmpty(moment(state.effectiveDate).format('YYYY-MM-DD'), UkgDateFormat.LongDate)}</span>
                                                        <FontAwesomeIcon className={classes.arrowIcon} icon={faLongArrowRight} />
                                                    </React.Fragment>}
                                                <span style={{ fontSize: 16, marginLeft: state.effectiveDate !== null ? '' : 8 }}>{evalForeverDateToString(moment(state.endDate).format('YYYY-MM-DD'), t)}</span>
                                            </div>
                                        )
                                    })
                                    : <span style={{ fontWeight: 'bold' }}>{t('workPlanView.slide.noDatesDefinied')}</span>}
                            </div>
                            <div style={{ border: '1px solid #E7E7E7', marginBottom: 20, marginTop: 20 }}></div>
                        </div>
                    )
                    : ''}
                <div className={classes.formContent}>{content}</div>
            </div>
            {this.generateSidePanelSubmitButton(okDisabled)}
        </React.Fragment >
    }

    submitableForm = (ownersToUpdate) => {
        const { selectedWorkPlan } = this.props;
        const { action, startTime, duration, selectedStartDate, selectedEndDate, startOn } = this.state;
        switch (action) {
            case 'createPaycode':
                if (startTime === '' || duration === '') {
                    return false;
                }
                break;
            case WorkplanActions.EditRolloutWorkplan:
                if (selectedStartDate === selectedWorkPlan.startDate && selectedEndDate === selectedWorkPlan.endDate && startOn === selectedWorkPlan.startOn) {
                    return false;
                }
                break;
            case WorkplanActions.RolloutWorkplan:
            case WorkplanActions.PauseWorkplan:
            case WorkplanActions.ManageShiftLine:
            case WorkplanActions.PauseShiftLine:
            case WorkplanActions.StopShiftLine:
            case WorkplanActions.StopWorkplan:
            case WorkplanActions.PauseShiftLineOwner:
            case WorkplanActions.StopShiftLineOwner:
                if (selectedEndDate === null) {
                    return false;
                }
                break;
            case WorkplanActions.ManageOwners:
                if (ownersToUpdate.length === 0) {
                    return false;
                }
                break;
            default:
                return true
        }
        return true;
    }

    generateSidePanelSubmitButton = (disabledSubmit) => {
        const { updateShowSidePanel, updateSelectedPaycode } = this.props;

        const handleCancelClick = () => {
            updateShowSidePanel(false);
            updateSelectedPaycode('');
            this.clearSavedChanges();
        };

        return (
            <ActionButtons
                cancel={handleCancelClick}
                submit={() => this.handleSubmitSidePanel(this.state.action)}
                disabledSubmit={disabledSubmit}
            />
        )
    }

    clearSavedChanges = () => {
        this.setState({ ownersToSave: [], Reliefs: [], shiftSegmentsSended: [] })
    }

    handleAction = async (action, body, message) => {
        const { refreshWorkplan, updateSnackbar, updateShowSidePanel, updateSpinnerShow } = this.props;
        updateSpinnerShow(true);
        await axios.post(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/' + action, body, currentHttpOptions())
            .then((response) => {
                let errorMessage = aux.handleAPIErrors(response)
                if (errorMessage) {
                    this.props.updateSnackbar({
                        typeSnackbar: 'error',
                        messageSnackbar: errorMessage,
                        openSnackbar: true,
                    })
                } else {
                    refreshWorkplan().then(() => {
                        updateShowSidePanel(false);
                        updateSnackbar({
                            typeSnackbar: 'success',
                            messageSnackbar: message,
                            openSnackbar: true
                        });
                    });
                }
            })
            .catch(err => {
                let errorMessage = aux.handleAPIErrors(err.response)
                this.props.updateSnackbar({
                    typeSnackbar: 'error',
                    messageSnackbar: errorMessage,
                    openSnackbar: true,
                })
            });
        this.clearSavedChanges();
        
    }

    genManagerOwnersUpdated = () => {
        const { shiftLine, ownersToSave } = this.state;
        let ownersUpdated = [];
        for (const owner of ownersToSave) {
            let slOwner = shiftLine.owners.find(o => o.ownerEntityId === owner.ownerEntityId);
            if (!slOwner) {
                ownersUpdated.push({ ...owner, ownerEntityId: undefined });
            } else {
                if (slOwner.startDate !== owner.startDate || slOwner.endDate !== owner.endDate || (slOwner.employeeId !== owner.employeeId && slOwner.employeeFullName !== owner.employeeFullName) || owner.markedForDeletion) {
                    ownersUpdated.push(owner);
                }
            }
        }

        return ownersUpdated;
    }

    handleSubmitSidePanel = async (action) => {
        const { selectedWorkPlan, updateShowSidePanel, updateSelectedPaycode, selectedPaycode, updateSelectedWorkPlan, settingsList, genQuotas, t } = this.props;
        const {
            selectedEmployee,
            selectedStartDate,
            selectedEndDate,
            startTime,
            duration,
            startOn,
            note,
            isNewLine,
            lineId,
            shiftLine,
            Reliefs,
            ownersToSave,
            pushCoverage,
            pushPlanned,
            shiftSegmentsSended,
            shiftSegmentsSCP,
            shiftTemplateDay,
            shiftlineId,
            shift
        } = this.state;

        let body;
        let ownersUpdated = action === WorkplanActions.ManageOwners ? this.genManagerOwnersUpdated() : [];
        if (this.submitableForm(ownersUpdated)) {
            if (action === 'createPaycode') {
                updateSelectedPaycode({ ...selectedPaycode, startTime: moment(startTime, 'H:mm').format('YYYY-MM-DDTHH:mm:ss'), duration });
                updateShowSidePanel(false);
            } else if ((action === WorkplanActions.ManageAssignment && isNewLine) || (action === WorkplanActions.ManageOwners && isNewLine)) {
                let workplan = Object.assign({}, selectedWorkPlan);
                let sl = workplan.shiftLines.find(shiftLine => shiftLine.lineId === lineId);

                if (exists(sl)) {
                    sl.employeeId = selectedEmployee.employeeId;
                    sl.employeeFullName = selectedEmployee.employeeName;
                    sl.EmployeeChanged = true;

                    const workplanSettings = settingsList.find((setting) => setting.id === selectedWorkPlan.adminSettingId) || {};
                    const enableSystemCoverage = workplanSettings.content.coverage.enableSystemCoverage;
                    workplan.quotas = await genQuotas(workplan, enableSystemCoverage);
                    updateSelectedWorkPlan(workplan);
                    updateShowSidePanel(false);
                }
            } else {
                let auxAction = action
                switch (action) {
                    case WorkplanActions.AddJobTransfer:
                        body = {
                            WorkplanId: selectedWorkPlan.workplanId,
                            ShiftlineEntityId: shiftlineId,
                            ShiftTemplateId: shift.id,
                            Segments: shiftSegmentsSended,
                            Day: shiftTemplateDay
                        }
                        auxAction = "AddTransferToShiftTemplate";
                        break;
                    case WorkplanActions.ManageAssignment:
                        body = {
                            Reliefs: Reliefs,
                            shiftLineEntityId: shiftLine.shiftLineId,
                            WorkplanId: selectedWorkPlan.workplanId,
                        }
                        auxAction = WorkplanActions.ManageReliefs;
                        break;
                    case WorkplanActions.ManageOwners:
                        body = {
                            WorkplanId: selectedWorkPlan.workplanId,
                            ShiftLineEntityId: shiftLine.shiftLineId,
                            Owners:
                                shiftLine.states.length === 0 && ownersUpdated[0].markedForDeletion !== true && ownersUpdated[0].detailsChanged !== true ?
                                    ownersToSave.map(owner => {
                                        return {
                                            workplanId: selectedWorkPlan.workplanId,
                                            shiftLineEntityId: shiftLine.shiftLineId,
                                            employeeId: owner.employeeId,
                                            employeeName: owner.employeeFullName,
                                            owners: [{
                                                ShiftLineEntityId: shiftLine.shiftLineId,
                                                EmployeeId: owner.employeeId,
                                                EmployeeName: owner.employeeFullName
                                            }],
                                            isReliefsDatesUpdated: owner.isReliefsDatesUpdated,
                                        }
                                    })
                                    :
                                    ownersUpdated.map(owner => {
                                        return {
                                            detailsChanged: owner.detailsChanged,
                                            isNew: !exists(owner.ownerEntityId),
                                            shiftLineEntityId: shiftLine.shiftLineId,
                                            ownerEntityId: owner.ownerEntityId,
                                            employeeId: owner.employeeId,
                                            employeeName: owner.employeeFullName,
                                            startDate: owner.startDate !== null ? owner.startDate : null,
                                            endDate: evalForeverToNull(owner.endDate),
                                            isReliefsDatesUpdated: owner.isReliefsDatesUpdated,
                                            isJobTransfer: owner.isJobTransfer,
                                            markedForDeletion: owner.markedForDeletion,
                                        }
                                    })
                        }
                        auxAction = shiftLine.states.length === 0 && ownersUpdated[0].markedForDeletion !== true && ownersUpdated[0].detailsChanged !== true ? "AssignOwnersToShiftLine" : "ManageOwners";
                        break;
                    case WorkplanActions.PauseShiftLineOwner:
                        body = {
                            Reliefs: Reliefs,
                            WorkplanId: selectedWorkPlan.workplanId,
                            ShiftLineEntityId: shiftLine.shiftLineId,
                            EffectiveDate: evalForeverStringToDate(selectedStartDate),
                            EndDate: evalForeverStringToDate(selectedEndDate)
                        }
                        auxAction = WorkplanActions.PauseShiftLineOwner
                        break;
                    case WorkplanActions.StopShiftLineOwner:
                        body = {
                            Reliefs: Reliefs,
                            WorkplanId: selectedWorkPlan.workplanId,
                            ShiftLineEntityId: shiftLine.shiftLineId,
                            EndDate: evalForeverStringToDate(selectedEndDate)
                        }
                        auxAction = WorkplanActions.StopShiftLineOwner
                        break;
                    case WorkplanActions.RolloutWorkplan:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            EffectiveDate: selectedStartDate,
                            EndDate: evalForeverToNull(selectedEndDate),
                            StartDateOffset: parseInt(startOn),
                            Note: note,
                            PushCoverage: pushCoverage,
                            PushPlanned: pushPlanned
                        }
                        break;
                    case WorkplanActions.PauseWorkplan:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            EffectiveDate: selectedStartDate,
                            EndDate: evalForeverToNull(selectedEndDate),
                            Note: note
                        }
                        break;
                    case WorkplanActions.StopWorkplan:
                    case WorkplanActions.EditStopWorkplan:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            EndDate: evalForeverStringToDate(selectedEndDate),
                            Note: note
                        }
                        break;
                    case WorkplanActions.ManageShiftLine:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            ShiftLineEntityId: shiftLine.shiftLineId,
                            EffectiveDate: selectedStartDate,
                            EndDate: evalForeverStringToDate(selectedEndDate),
                        }
                        break;
                    case WorkplanActions.PauseShiftLine:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            ShiftLineEntityId: shiftLine.shiftLineId,
                            EffectiveDate: selectedStartDate,
                            EndDate: evalForeverStringToDate(selectedEndDate),
                            Note: note,
                            Noteaa: 'note'
                        }
                        break;
                    case WorkplanActions.EditPauseShiftLine:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            ShiftLineId: shiftLine.shiftLineId,
                            StartDate: selectedStartDate,
                            EndDate: evalForeverStringToDate(selectedEndDate),
                            Note: note,
                            Noteaa: 'note'
                        }
                        break;
                    case WorkplanActions.EditStopShiftLine:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            ShiftLineId: shiftLine.shiftLineId,
                            EndDate: evalForeverStringToDate(selectedEndDate)
                        }
                        break;

                    case WorkplanActions.StopShiftLine:
                        body = {
                            WorkPlanId: selectedWorkPlan.workplanId,
                            ShiftLineEntityId: shiftLine.shiftLineId,
                            EndDate: evalForeverStringToDate(selectedEndDate)
                        }
                        break;
                    case WorkplanActions.EditRolloutWorkplan:
                        body = {
                            workPlanId: selectedWorkPlan.workplanId,
                            effectiveDate: selectedStartDate,
                            endDate: evalForeverStringToDate(selectedEndDate),
                            startDateOffset: startOn,
                        }
                        break
                    case WorkplanActions.EditPauseWorkplan:
                        body = {
                            workPlanId: selectedWorkPlan.workplanId,
                            effectiveDate: selectedStartDate,
                            endDate: evalForeverStringToDate(selectedEndDate),
                            workplanStateId: selectedWorkPlan.states.find(state => state.status === 1).id,
                        }
                        break
                    case WorkplanActions.SetSkillAndCertificationProfiles:
                        body = {
                            WorkplanId: selectedWorkPlan.workplanId,
                            ShiftlineEntityId: shiftlineId,
                            ShiftTemplateId: shift.id,
                            Segments: shiftSegmentsSCP.map((shiftSegment) => ({
                                ...shiftSegment,
                                segmentSCProfiles: shiftSegment.segmentSCProfiles !== null
                                ? shiftSegment.segmentSCProfiles.map((segmentSCProfile) => ({
                                    id: segmentSCProfile.value, 
                                    qualifier: segmentSCProfile.label 
                                }))
                                : null
                            })),
                            Day: shiftTemplateDay
                        }
                        auxAction = "SetSkillAndCertificationProfilesToShiftTemplate";
                        break
                    default:
                        break;
                }
                this.handleAction(auxAction, body, t('workPlan.success' + auxAction));
            }
        }
    }

    render() {
        const { updateShowSidePanel, showSidePanel, classes } = this.props;
        const { formTitle } = this.state;

        return (
            <React.Fragment>
                <SideBar
                    handleDrawerClose={() => updateShowSidePanel(false)}
                    open={showSidePanel}
                    className={classes.sideBar}
                    title={<Typography className={classes.sideBarTitle}>{formTitle}</Typography>}
                >
                    {this.generateSidePanelContent()}
                </SideBar>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedWorkPlan: state.selectedWorkPlan,
        schedulePatternsTemplates: state.schedulePatternsTemplates,
        showSidePanel: state.showSidePanel,
        snackbar: state.snackbar,
        httpOptions: state.httpOptions,
        paycodeList: state.paycodeList,
        sidePanelData: state.sidePanelData,
        selectedPaycode: state.selectedPaycode,
        skillAndCertificationProfiles: state.skillAndCertificationProfiles
    }
}

const mapDispatchToProps = {
    updateShowSidePanel,
    updateSnackbar,
    updateSelectedPaycode,
    updateSelectedWorkPlan,
    updateSpinnerShow
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(withStyles(styles)(ActionForm)));